import React from 'react';

import { isDevice } from '$/utils/isMobile';
import { RoomType } from '$/GraphQL/schema/schema';

import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { PlayerMode } from '$/components/WebinarPlayer/types';

import VideoTimer from './VideoTimer';
import { AgendaButton } from './Agenda';
import VolumeControl from './VolumeControl';
import LikeReactions from './LikeReactions';
import { CCPlayerButton } from './CCPlayerButton';
import FullScreenButton from './FullScreenButton';
import TimeScrobbleControl from './TimeScrobbleControl';
import { SpeedControlButton } from './SpeedControlButton';
import { QualityControlButton } from './QualityControlButton';

const SessionVideoControlsBar: React.FC = withWebinarPlayerContext(
  ['set', 'hasAgenda', 'mode', 'editMode', 'player', 'currentRoom', 'ewebinar'],
  'SessionVideoControlsBar'
)(({ context }) => {
  const { set, hasAgenda, mode, editMode, currentRoom, ewebinar } = context;
  const inPlaybackMode = [PlayerMode.live, PlayerMode.replay].includes(mode);

  return (
    <>
      <div id='leftControls' className='flex items-center'>
        {hasAgenda && <AgendaButton />}
        {!isDevice && <VolumeControl />}
        {currentRoom.caps.playsVideo && (
          <>
            <CCPlayerButton />
            <SpeedControlButton />
            <QualityControlButton />
          </>
        )}
        {!isDevice && editMode !== 'edit.modal' && <FullScreenButton />}
      </div>

      {currentRoom.caps.playsVideo &&
        mode === PlayerMode.replay &&
        !set.setSettings.replaySettings?.disallowSeek && (
          <div className='flex flex-1'>
            <TimeScrobbleControl presentationOnly />
          </div>
        )}

      <div id='rightControls' className='flex items-center gap-1'>
        {ewebinar.viewerRoomSettings?.enableVideoTimer &&
          mode === PlayerMode.live &&
          currentRoom.type === RoomType.Presentation && <VideoTimer />}
        {currentRoom.caps.playsVideo && inPlaybackMode && (
          <LikeReactions showReactionBtn={currentRoom.type === RoomType.Presentation} />
        )}
      </div>
    </>
  );
});

export default SessionVideoControlsBar;
